import React from 'react';
import { cn } from '@shared/ui/utils/tailwind';

export type StackProps = React.HTMLAttributes<HTMLDivElement> & {
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number | string;
  align?: 'stretch' | 'center' | 'flex-start' | 'flex-end';
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around';
  className?: string;
};

const GAP_MAP: Record<string, string> = {
  xs: '0.25rem', sm: '0.5rem', md: '1rem', lg: '1.5rem', xl: '2rem',
};

const ALIGN_CLASSES: Record<string, string> = {
  stretch: 'items-stretch', center: 'items-center', 'flex-start': 'items-start', 'flex-end': 'items-end',
};

const JUSTIFY_CLASSES: Record<string, string> = {
  'flex-start': 'justify-start', center: 'justify-center', 'flex-end': 'justify-end', 'space-between': 'justify-between', 'space-around': 'justify-around',
};

function resolveGap(gap: StackProps['gap']): string {
  if (gap == null) return '1rem';
  if (typeof gap === 'number') return `${gap}px`;
  return GAP_MAP[gap] ?? gap;
}

export const Stack: React.FC<StackProps> = ({
  gap = 'md', align = 'stretch', justify = 'flex-start', className, children, style, ...props
}) => {
  return (
    <div
      className={cn('flex flex-col', ALIGN_CLASSES[align], JUSTIFY_CLASSES[justify], className)}
      style={{ gap: resolveGap(gap), ...style }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Stack;
